module.exports = "/_next/static/images/5-40cf9c21f6163ee70c9a898b7f8674fc.svg";